import Image from 'app/Components/Shared/Image/image';
import React from 'react'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';


function AddonsCancellationNoticePopup({addons,onClose}) {

    return (
       <div className='notice-popup-container'>
          <Image src={require('../images/info.svg')} />
          <span className='title'>חשוב לנו שתדעו</span>
          <span className='description'>ביטול חבילת החו"ל שברשותך תבטל גם את תוספת החבילות שנרכשו לחבילה זו:</span>
          <div className='includedInPackage'>
             <ul> { addons.map((el,i)=>{return(<li key={i}>{el}</li>)}) }</ul>
          </div>
          <BtnSubmit onclick={onClose} text={' הבנתי, תודה'}></BtnSubmit>
       </div> 
    )
}

export default AddonsCancellationNoticePopup
